import { ErrorPage } from '@zillow/zrs-zillow-offers';

import HeadWrapper from '../../components/HeadWrapper';
import { StyledPage } from '../../containers/NotFoundPage/StyledComponents';

import ErrorMessageConstants from '../../constants/ErrorMessageConstants';

type TechnicalDifficultiesPageProps = {
  errorCode?: number;
  errorMessage?: string;
  title?: string;
};

const TechnicalDifficultiesPage = ({
  errorCode = 500,
  errorMessage = ErrorMessageConstants.TECHNICAL_DIFFICULTIES,
  title = 'Technical difficulties',
}: TechnicalDifficultiesPageProps) => (
  <StyledPage noPadding={true}>
    <>
      <HeadWrapper title={title} />

      <ErrorPage
        errorCode={errorCode}
        errorMessage={errorMessage}
        homePageText="Return to Zillow"
        homePageUrl="https://www.zillow.com"
      />
    </>
  </StyledPage>
);

export default TechnicalDifficultiesPage;
